import { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Botao, Campo, Entrada } from '../componentes/ui';
import { ErroApi } from '../lib/api';
import { useOperador } from '../lib/sessao-operador';

/**
 * O login da PLATAFORMA.
 *
 * ## Por que ele não parece com o login do produto
 * O do escritório é a vitrine: carrossel, identidade, promessa. Este é uma
 * porta de serviço, e a diferença visual é funcional — quem abre esta tela por
 * engano precisa perceber na primeira olhada que está no lugar errado. Um
 * login idêntico ao do cliente convidaria o contador a tentar a senha dele
 * aqui.
 *
 * ## O que ele NÃO tem
 * Nada de "esqueci minha senha", e nada de autocadastro: operador é criado por
 * comando no servidor (`scripts/criar-operador.mjs`), e a recuperação passa por
 * quem tem acesso à máquina. Um fluxo de recuperação por e-mail nesta porta
 * seria o caminho mais curto para dentro de todos os escritórios.
 */
export function OperadorEntrar(): JSX.Element {
  const entrar = useOperador((s) => s.entrar);
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const enviar = async (evento: React.FormEvent) => {
    evento.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (e) {
      // A mensagem do servidor é a mesma para e-mail inexistente e senha
      // errada, de propósito — ver `OperadorService.entrar`.
      setErro(e instanceof ErroApi ? e.message : 'Não foi possível entrar.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="bg-palco flex min-h-dvh items-center justify-center p-4">
      <form
        onSubmit={enviar}
        noValidate
        className="border-tinta-100 bg-superficie sombra-cartao flex w-full max-w-sm flex-col gap-4 rounded-xl border p-6"
      >
        <div className="flex items-center gap-2">
          <ShieldCheck aria-hidden className="text-marca-600 size-5" />
          <h1 className="text-tinta-900 text-lg font-bold">Operação Specializer</h1>
        </div>

        <p className="text-tinta-500 text-sm">
          Acesso da equipe. Este login não é o do seu escritório.
        </p>

        {erro && (
          <p
            role="alert"
            className="bg-erro-100 text-erro-600 rounded-lg px-4 py-3 text-sm"
          >
            {erro}
          </p>
        )}

        <Campo rotulo="E-mail" id="emailOperador" obrigatorio>
          <Entrada
            id="emailOperador"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Campo>

        <Campo rotulo="Senha" id="senhaOperador" obrigatorio>
          <Entrada
            id="senhaOperador"
            type="password"
            autoComplete="current-password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </Campo>

        <Botao type="submit" carregando={enviando}>
          Entrar na operação
        </Botao>

        <p className="text-tinta-500 text-xs">
          A sessão dura 30 minutos e termina ao fechar a aba. Não há recuperação de senha
          por aqui.
        </p>
      </form>
    </div>
  );
}
